import React, { forwardRef } from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-[0.98]';
  const variants = {
    primary: 'bg-brand-primary text-white hover:bg-brand-light focus:ring-brand-primary shadow-md hover:shadow-lg',
    secondary: 'bg-brand-dark text-white hover:bg-brand-dark-secondary focus:ring-brand-dark shadow-md',
    outline: 'border-2 border-slate-200 bg-transparent text-brand-dark hover:bg-slate-50 focus:ring-slate-200',
    ghost: 'bg-transparent text-slate-600 hover:bg-slate-100 hover:text-brand-dark'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <button ref={ref} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={isLoading || props.disabled} {...props} data-id="element-361" data-mp="onkgb5fjrced">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-362" data-mp="xnh3f2mag37b" />}
        {children}
      </button>;
});
Button.displayName = 'Button';